import { SUBURBS_DETAILED } from "@/data/suburbs";

// Main pages: title/desc are admin-editable via these content keys (defaults match the page code).
export const MAIN_PAGES = [
  {
    route: "/",
    label: "Home",
    titleKey: "meta_home_title",
    descKey: "meta_home_desc",
    defaultTitle: "Grab Rails, Hand Rails & Rubber Ramps Perth | Modify",
    defaultDesc:
      "Specialist grab rail, hand rail and rubber ramp supply and professional installation across Perth, WA. We care about making everyday living safer. Free quotes.",
  },
  {
    route: "/grab-rails",
    label: "Grab Rails",
    titleKey: "meta_grab_title",
    descKey: "meta_grab_desc",
    defaultTitle: "Grab Rails Perth | Supplied & Installed | Modify",
    defaultDesc:
      "Grab rails supplied and professionally installed across Perth — bathrooms, showers, toilets and walls. Brick or stud, we plan the right fixing. Free quote.",
  },
  {
    route: "/hand-rails",
    label: "Hand Rails",
    titleKey: "meta_hand_title",
    descKey: "meta_hand_desc",
    defaultTitle: "Hand Rails Perth | Supplied & Installed | Modify",
    defaultDesc:
      "Hand rails supplied and professionally installed across Perth — stairs, steps, entrances and pathways. Secure the whole route. Free quote from Modify.",
  },
  {
    route: "/rubber-ramps",
    label: "Rubber Ramps",
    titleKey: "meta_ramps_title",
    descKey: "meta_ramps_desc",
    defaultTitle: "Rubber Ramps Perth | Supplied & Installed | Modify",
    defaultDesc:
      "Rubber threshold ramps supplied and professionally installed across Perth — smooth, safe access over steps and doorways. Free quote from Modify.",
  },
  {
    route: "/gallery",
    label: "Gallery",
    titleKey: "meta_gallery_title",
    descKey: "meta_gallery_desc",
    defaultTitle: "Our Work | Grab Rails, Hand Rails & Ramps Perth | Modify",
    defaultDesc:
      "See real Modify installations across Perth — grab rails, hand rails and rubber ramps fitted in local homes. Every photo is a genuine Modify job.",
  },
  {
    route: "/reviews",
    label: "Reviews",
    titleKey: "meta_reviews_title",
    descKey: "meta_reviews_desc",
    defaultTitle: "Reviews | 5.0-Star Google Rating | Modify Perth",
    defaultDesc:
      "Perth homeowners rate Modify 5.0 on Google for grab rail, hand rail and rubber ramp installations. Read genuine reviews from real local customers.",
  },
  {
    route: "/contact",
    label: "Contact",
    titleKey: "meta_contact_title",
    descKey: "meta_contact_desc",
    defaultTitle: "Contact Modify | Grab Rails & Ramps Perth | Free Quotes",
    defaultDesc:
      "Call Modify on 0480 554 777 or request a free quote online. Grab rails, hand rails and rubber ramps supplied and installed across Perth, WA.",
  },
];

// Suburb pages: metas are generated from a fixed template in SuburbPage.jsx (not admin-editable).
export const SUBURB_PAGES = SUBURBS_DETAILED.map((s) => ({
  route: `/areas/${s.slug}`,
  label: `${s.name} (suburb page)`,
  titleKey: null,
  descKey: null,
  defaultTitle: `Grab Rails ${s.name} | Hand Rails & Ramps | Modify`,
  defaultDesc: `Grab rails, hand rails and rubber ramps supplied and professionally installed across ${s.name}, WA. Local, careful installation. Free quotes from Modify.`,
}));

export const SEO_IDEAL = {
  titleMin: 30,
  titleMax: 60,
  descMin: 120,
  descMax: 160,
};
